"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuBody = void 0;
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var hooks_1 = require("../../../../mantine-hooks/src");
var theme_1 = require("../../../../mantine-theme/src");
var Transition_1 = require("../../Transition/Transition");
var Paper_1 = require("../../Paper/Paper");
var Hr_1 = require("../../Hr/Hr");
var MenuItem_1 = require("../MenuItem/MenuItem");
var MenuButton_1 = require("../MenuButton/MenuButton");
var MenuBody_styles_1 = __importDefault(require("./MenuBody.styles"));
function getPreviousItem(active, items) {
    for (var i = active - 1; i >= 0; i -= 1) {
        if (!items[i].props.disabled && items[i].type === MenuItem_1.MenuItem) {
            return i;
        }
    }
    return active;
}
function getNextItem(active, items) {
    for (var i = active + 1; i < items.length; i += 1) {
        if (!items[i].props.disabled && items[i].type === MenuItem_1.MenuItem) {
            return i;
        }
    }
    return active;
}
function findInitialItem(items) {
    for (var i = 0; i < items.length; i += 1) {
        if (!items[i].props.disabled && items[i].type === MenuItem_1.MenuItem) {
            return i;
        }
    }
    return -1;
}
function MenuBody(_a) {
    var className = _a.className, themeOverride = _a.themeOverride, opened = _a.opened, onClose = _a.onClose, _b = _a.transition, transition = _b === void 0 ? 'skew-up' : _b, _c = _a.transitionDuration, transitionDuration = _c === void 0 ? 250 : _c, transitionTimingFunction = _a.transitionTimingFunction, style = _a.style, children = _a.children, _d = _a.size, size = _d === void 0 ? 'md' : _d, _e = _a.shadow, shadow = _e === void 0 ? 'md' : _e, _f = _a.closeOnClickOutside, closeOnClickOutside = _f === void 0 ? true : _f, _g = _a.closeOnItemClick, closeOnItemClick = _g === void 0 ? true : _g, _h = _a.zIndex, zIndex = _h === void 0 ? 1000 : _h, others = __rest(_a, ["className", "themeOverride", "opened", "onClose", "transition", "transitionDuration", "transitionTimingFunction", "style", "children", "size", "shadow", "closeOnClickOutside", "closeOnItemClick", "zIndex"]);
    var items = react_1.default.Children.toArray(children).filter(function (item) { return item.type === MenuItem_1.MenuItem || item.type === Hr_1.Hr; });
    var hoveredTimeout = react_1.useRef();
    var buttonsRefs = react_1.useRef({});
    var theme = theme_1.useMantineTheme(themeOverride);
    var classes = MenuBody_styles_1.default({ size: size, theme: theme });
    var reduceMotion = hooks_1.useReducedMotion();
    var duration = reduceMotion ? 0 : transitionDuration;
    var _j = react_1.useState(findInitialItem(items)), hovered = _j[0], setHovered = _j[1];
    var focusTrapRef = hooks_1.useFocusTrap();
    react_1.useEffect(function () {
        if (!opened) {
            hoveredTimeout.current = window.setTimeout(function () {
                setHovered(findInitialItem(items));
            }, duration);
        }
        else {
            window.clearTimeout(hoveredTimeout.current);
        }
    }, [opened]);
    var menuRef = hooks_1.useClickOutside(function () { return closeOnClickOutside && onClose(); });
    var handleKeyDown = function (event) {
        var code = event.nativeEvent.code;
        if (code === 'Escape') {
            onClose();
        }
        if (code === 'Tab') {
            event.preventDefault();
        }
        if (code === 'ArrowUp') {
            event.preventDefault();
            var prevIndex = getPreviousItem(hovered, items);
            setHovered(prevIndex);
            buttonsRefs.current[prevIndex].focus();
        }
        if (code === 'ArrowDown') {
            event.preventDefault();
            var nextIndex = getNextItem(hovered, items);
            setHovered(nextIndex);
            buttonsRefs.current[nextIndex].focus();
        }
    };
    if (items.length === 0) {
        return null;
    }
    var buttons = items.map(function (item, index) {
        if (item.type === MenuItem_1.MenuItem) {
            return (react_1.default.createElement(MenuButton_1.MenuButton, __assign({}, item.props, { key: index, hovered: hovered === index, onHover: function () { return setHovered(-1); }, onClick: function (event) {
                    if (closeOnItemClick) {
                        onClose();
                    }
                    if (typeof item.props.onClick === 'function') {
                        item.props.onClick(event);
                    }
                }, elementRef: function (node) {
                    buttonsRefs.current[index] = node;
                } })));
        }
        if (item.type === Hr_1.Hr) {
            return react_1.default.createElement(Hr_1.Hr, { key: index, variant: "solid", className: classes.hr });
        }
        return null;
    });
    return (react_1.default.createElement(Transition_1.Transition, { mounted: opened, duration: duration, transition: transition, timingFunction: transitionTimingFunction, themeOverride: themeOverride }, function (transitionStyles) { return (react_1.default.createElement(Paper_1.Paper, __assign({ shadow: shadow, className: clsx_1.default(classes.menu, className), style: __assign(__assign(__assign({}, style), transitionStyles), { zIndex: zIndex }), onKeyDownCapture: handleKeyDown, elementRef: menuRef, role: "menu", "aria-orientation": "vertical" }, others),
        react_1.default.createElement("div", { ref: focusTrapRef }, buttons))); }));
}
exports.MenuBody = MenuBody;
MenuBody.displayName = '@mantine/core/MenuBody';
